import React from "react";
import PropTypes from "prop-types";
import NeoTable from "../../../../../components/Common/NeoTable";
import NeoCard from "../../../../../components/Common/NeoCard";

const DetailUsers = ({ schoolUsers }) => {
    // Colunas da NeoTable para Usuários (compactadas)
    const usersColumns = [
        {
            key: "name",
            label: "Nome Completo",
            width: "35%",
            render: (row) => (
                <div className="d-flex align-items-center gap-2">
                    <div
                        className="avatar-title text-white rounded-circle d-flex align-items-center justify-content-center fw-bold animate__animated animate__zoomIn animate__faster"
                        style={{
                            width: "32px",
                            height: "32px",
                            minWidth: "32px",
                            background: "linear-gradient(135deg, #f97316 0%, #ef4444 100%)",
                            boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                            fontSize: "11px",
                            flexShrink: 0
                        }}
                    >
                        {row.name.substring(0, 2).toUpperCase()}
                    </div>
                    <span className="fw-bold text-dark font-size-14">{row.name}</span>
                </div>
            )
        },
        {
            key: "email",
            label: "Email",
            width: "25%",
            render: (row) => <span>{row.email}</span>
        },
        {
            key: "role",
            label: "Cargo / Status",
            width: "20%",
            render: (row) => (
                <div>
                    <span className="badge bg-secondary-subtle text-secondary rounded d-inline-block">{row.role}</span>
                    <span className="badge bg-success-subtle text-success rounded d-block mt-0.5" style={{ width: "fit-content" }}>{row.status}</span>
                </div>
            )
        },
        {
            key: "lastLogin",
            label: "Último Acesso",
            width: "20%",
            render: (row) => <span>{row.lastLogin}</span>
        }
    ];

    return (
        <NeoCard
            title="Usuários da Academia"
            subtitle="Usuários cadastrados com acesso ao painel administrativo da academia"
            thinBorder={true}
            bodyClassName="p-0"
        >
            <NeoTable
                columns={usersColumns}
                data={schoolUsers}
                emptyMessage="Nenhum usuário cadastrado"
            />
        </NeoCard>
    );
};

DetailUsers.propTypes = {
    schoolUsers: PropTypes.array.isRequired
};

export default DetailUsers;
